import { useState, useEffect, useCallback } from 'react';
import supabase, { orgId } from '../supabaseClient';

const MONTH_KEY = 'current_month_idx';
const START_KEY = 'forecast_start_date';
const FC_KEY    = 'functional_currency';

export default function useCurrentMonth() {
  const [currentMonthIdx, setCurrentMonthIdx] = useState(null);
  const [startDate, setStartDate]             = useState(null);
  const [functionalCurrency, setFC]           = useState('USD');
  const [loading, setLoading]                 = useState(true);

  useEffect(() => {
    async function load() {
      const { data } = await supabase
        .from('app_settings')
        .select('key, value')
        .eq('org_id', orgId)
        .in('key', [MONTH_KEY, START_KEY, FC_KEY]);

      (data || []).forEach(row => {
        try {
          const parsed = JSON.parse(row.value);
          if (row.key === MONTH_KEY) setCurrentMonthIdx(parsed ?? null);
          if (row.key === START_KEY) setStartDate(parsed ?? null);
          if (row.key === FC_KEY)    setFC(parsed || 'USD');
        } catch (_) {}
      });
      setLoading(false);
    }
    load();
  }, []);

  const upsert = async (key, value) => {
    await supabase.from('app_settings').upsert(
      { org_id: orgId, key, value: JSON.stringify(value) },
      { onConflict: 'org_id,key' }
    );
  };

  const updateCurrentMonth      = useCallback(async (v) => { setCurrentMonthIdx(v); await upsert(MONTH_KEY, v); }, []);
  const updateStartDate         = useCallback(async (v) => { setStartDate(v);         await upsert(START_KEY, v); }, []);
  const updateFunctionalCurrency= useCallback(async (v) => { setFC(v);               await upsert(FC_KEY, v);    }, []);

  return { currentMonthIdx, startDate, functionalCurrency, loading, updateCurrentMonth, updateStartDate, updateFunctionalCurrency };
}
